(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ViaController', ViaController);

    ViaController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Via', '$uibModal', 'ConfirmationService',
        '$q'];

    function ViaController(GenericEntityDatatableService, CoreService, Via, $uibModal, ConfirmationService,
                           $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Via',
            newButtonTitle: 'New Via',
            entityClassHumanized: 'Via',
            entityStateName: 'via',
            service: Via,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Via',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/via/update/via-dialog.html',
                controller: 'ViaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/via/update/via-dialog.html',
                controller: 'ViaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Via', function (Via) {
                        return Via.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Via').result.then(function () {
                    Via.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
